import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable, of } from 'rxjs';
import { UsersService } from '../../../../data-services/users.service';
import { CommonDisplayActionService } from '../../common/common-display-action.service';
import { CommonDisplayActivityService } from '../../common/common-display-activity.service';
import { SendNotificationDisplayService } from '../send-notification-common';

/**
 * <h1> IMPORTANT </h1>
 *
 * Do not implement new actions, triggers, and filters using {@link CommonDisplayActionService}
 * nor {@link CommonDisplayActivityService}. These classes are deprecated, retained for backward
 * compatibility only, and <strong> are likely to be removed in the future. </strong>
 * Instead, subclass from {@link AutomationDisplayService} as this implements all modern interfaces,
 * provides convenience methods to make code more concise and readable,
 * and provides adapters to the old system while it is being phased out.
 * @see AutomationDisplayService
 * @example AddTagService
 */
@Injectable({ providedIn: 'root' })
export class SendNotificationSalespersonService implements CommonDisplayActivityService, CommonDisplayActionService {
  constructor(
    private readonly translateService: TranslateService,
    public sanitizer: DomSanitizer,
    private readonly usersService: UsersService,
    private commonNotificationDisplayService: SendNotificationDisplayService,
  ) {}

  getActivitySubtitle(_namespace: string, _activity: ActivityInterface): Observable<string> {
    return of('');
  }

  getActivityTitle(_namespace: string, activity: ActivityInterface): Observable<string> {
    const activityData = activity?.activityData ? JSON.parse(activity.activityData) : {};
    const userIds = activityData?.user_ids || [];
    return this.commonNotificationDisplayService.getActivityTitle(userIds);
  }

  getTemplateActionSubtitle(_namespace: string, step: WorkflowStepInterface): Observable<string> {
    return this.commonNotificationDisplayService.getTemplateActionSubtitle(step, 'sales_person');
  }

  getActionSubtitle(_namespace: string, step: WorkflowStepInterface): Observable<string> {
    return this.commonNotificationDisplayService.getActionSubtitle(
      step,
      'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.ACTIONS.TO_MULTIPLE_SALESPEOPLE',
      'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.ACTIONS.TO_ASSIGNED_SALESPERSON',
      'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.ACTIONS.TO_ADDITIONAL_SALESPEOPLE',
    );
  }

  getActionSubtitleSuccessState(data: any): Observable<string> {
    const userIds = data?.user_ids || [];
    return this.commonNotificationDisplayService.getActivityTitle(userIds);
  }

  getActionSubtitleErrorState(_data: any, _step: WorkflowStepInterface): Observable<string> {
    return of('');
  }

  getActionSubtitleEmptyState(data: any): Observable<string> {
    const userIds = data?.user_ids || [];
    return this.commonNotificationDisplayService.getActivityTitle(userIds);
  }
}
